module.exports = __webpack_public_path__ + "static/media/smcswapLogo.da1118a2.svg";